import React from 'react';
import {PropTypes} from 'prop-types';

export class AppDetailInfoContentRow extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    className: PropTypes.string,
    wasEdited: PropTypes.bool
  };

  static defaultProps = {
    content: '',
    title: '',
    className: '',
    wasEdited: false
  };

  render() {
    return (<div className={`app-info-text-content ${this.props.className} ${this.props.wasEdited && 'was-edited'}`}>
      <dt className="title">{this.props.title}:</dt>
      {this.props.wasEdited && <span className="sr-only">This field was edited</span>}
      <dd className="content">{this.props.content}</dd>
    </div>);
  }
}
